import React from "react";
import "./styles.less";

export const CardOne = (props) => {
  const { title, subtitle, links = null, aside = null, icon } = props;
  return (
    <>
      <div className="card-one">
        <div className="content-box">
          <div className="card-icon">{icon}</div>
          <div className="content">
            <div className="title">{title}</div>
            <div className="subtitle">{subtitle}</div>
            <div className="links">
              {links &&
                links.map((item, index) => {
                  return (
                    <a key={index} href={item.adress} target="_blank" rel="noopener noreferrer" className="link-item">
                      {item.text}
                    </a>
                  );
                })}
            </div>
          </div>
        </div>
        <div className="button">{aside}</div>
      </div>
    </>
  );
};
